/* eslint-disable import/prefer-default-export */

// collection items
import CollectionAuthorItem from 'components/SearchResultsItem/Collection/AuthorItem';
import CollectionBookItem from 'components/SearchResultsItem/Collection/BookItem';
import CollectionCollectionItem from 'components/SearchResultsItem/Collection/CollectionItem';
import FavouriteCollectionItem from 'components/SearchResultsItem/Collection/FavouriteCollectionItem';

// search items
import SearchAuthorItem from 'components/SearchResultsItem/Search/AuthorItem';
import SearchBookItem from 'components/SearchResultsItem/Search/BookItem';
import SearchCollectionItem from 'components/SearchResultsItem/Search/CollectionItem';
import SearchRecipeItem from 'components/SearchResultsItem/Search/RecipeItem';
import SearchReferenceItem from 'components/SearchResultsItem/Search/ReferenceItem';

// @deprecated - no more copy/paste of components for trivial differences please!
// ElasticSearch results can easily be mapped onto the GraphQL model (see Search/RecipeItem.js).
export const CollectionItemComponent = {
  Author: CollectionAuthorItem,
  Book: CollectionBookItem,
  Collection: CollectionCollectionItem,
  FavouriteCollection: FavouriteCollectionItem,
};

export const SearchItemComponent = {
  Author: SearchAuthorItem,
  Book: SearchBookItem,
  Collection: SearchCollectionItem,
  Recipe: SearchRecipeItem,
  Reference: SearchReferenceItem,
};
